import { useEffect } from 'react';

import useDomainUrl from './useDomainUrl';

const useBlockIframe = () => {
    const { getDomainUrl } = useDomainUrl();

    useEffect(() => {
        // Block rendering if in an iframe
        if (window.self !== window.top) {
            window.location.href = getDomainUrl('error/403', false, false); // Redirect to forbidden page for block access
        }
    }, []);
};

export default useBlockIframe;
